
import {Component} from 'vue-property-decorator'
import Vue from 'vue'
import {validationMixin} from 'vuelidate'
import {namespace} from 'vuex-class'
import ConseillerForm from '@/components/forms/ConseillerForm.vue'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'

const uiModule = namespace('ui')
const authModule = namespace('auth')

@Component({
  mixins: [validationMixin],
  components: {
    ConseillerForm,
    BaseCardContainer
  }
})
export default class App extends Vue {
  @authModule.Getter('meGetter') me: any
  @uiModule.Getter('isLoadingGetter') isLoading: any
  @authModule.Action('meAction') getMe: any
  @authModule.Action('updateMeAction') updateMe: any

  mounted() {
    this.getMe()
  }

  onSubmit(data: any) {
    this.updateMe({
      formParams: data,
      queryParams: null
    }).then((data) => {
      Vue.notify({
        group: 'user',
        type: 'success',
        title: 'Confirmation',
        text: 'Les informations ont bien été modifiées !'
      })
    })
  }

  onCancel() {
    this.$router.go(-1)
  }
}
